import { connect } from 'react-redux';

import { StoreState } from '../../reducers';
import ProposalCreator from '../../components/ProposalCreator';
import { ProposalSource } from './reducer';

const mapStateToProps = (state: StoreState) => {
	const {
		proposalCreator: {
			isDisplayed,
			source,
		},
	} = state;

	return {
		isDisplayed,
		isFromFile: source === ProposalSource.FILE,
	};
};

export default connect(mapStateToProps)(ProposalCreator);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/ProposalCreator/index.tsx